<button
  [type]="type"
  class="app-button"
  [ngClass]="[
    'app-button--' + variant,
    'app-button--' + size,
    fullWidth ? 'app-button--full-width' : '',
    loading ? 'app-button--loading' : '',
    customClass
  ]"
  [style.width]="width ? width : (fullWidth ? '100%' : null)"
  [style.minWidth]="minWidth || null"
  [style.maxWidth]="maxWidth || null"
  [disabled]="disabled || loading"
  (click)="onClick($event)"
>
  <!-- Loading Spinner -->
  <span *ngIf="loading" class="app-button__spinner">
    <svg class="app-button__spinner-svg" viewBox="0 0 24 24">
      <circle class="app-button__spinner-circle" cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3"></circle>
    </svg>
  </span>

  <!-- Start Icon -->
  <span *ngIf="!loading && startIcon" class="app-button__start-icon">
    <img *ngIf="startIcon.includes('.svg') || startIcon.includes('/')" [src]="startIcon" alt="" />
    <i *ngIf="!startIcon.includes('.svg') && !startIcon.includes('/')" [class]="startIcon"></i>
  </span>

  <!-- Text / Projected Content -->
  <span class="app-button__text">
    <ng-container *ngIf="formattedText">{{ formattedText }}</ng-container>
    <ng-content></ng-content>
  </span>

  <!-- End Icon -->
  <span *ngIf="!loading && endIcon" class="app-button__end-icon">
    <img *ngIf="endIcon.includes('.svg') || endIcon.includes('/')" [src]="endIcon" alt="" />
    <i *ngIf="!endIcon.includes('.svg') && !endIcon.includes('/')" [class]="endIcon"></i>
  </span>
</button>
